export default __webpack_public_path__ + "static/dynamic-compound-intransitive-5f621b080401114dd332dad6a796820b.svg";